import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Stateless function representing a lane assist icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <LaneWeavingIcon width={12} />
 */
export function LaneWeavingIcon(props) {
    return (
        <SvgIcon viewBox="0 0 48 48" {...props}>
            <path d="m12,6v8c0,1.1-.9,2-2,2s-2-.9-2-2V6c0-1.1.9-2,2-2s2,.9,2,2Zm-2,26c-1.1,0-2,.9-2,2v8c0,1.1.9,2,2,2s2-.9,2-2v-8c0-1.1-.9-2-2-2Zm0-14c-1.1,0-2,.9-2,2v8c0,1.1.9,2,2,2s2-.9,2-2v-8c0-1.1-.9-2-2-2ZM36,4v40h4V4h-4Zm-1.47,16.64h0c-.01.06-.03.13-.04.19-.52,2.43-1.13,5.09-1.73,7.63-.01.04-.02.08-.03.12-.52,2.2-1.04,4.29-1.5,6.03-.01.05-.02.09-.04.14-.58,2.21-1.07,3.82-1.33,4.32-.43.83-1.07,1.37-1.94,1.67-1.24.43-2.94.34-5.15-.17s-3.78-1.18-4.71-2.1c-.65-.64-.99-1.42-1.01-2.35-.02-.57.26-2.23.7-4.47,0-.05.02-.09.03-.14.35-1.77.8-3.87,1.3-6.08,0-.04.02-.08.03-.12.57-2.54,1.2-5.2,1.79-7.61.02-.06.03-.12.05-.19h0s-1.05-.02-1.05-.02c.21-.9.83-.98,1.28-.91.76-3.01,1.44-5.49,1.85-6.62,1.42-3.9,7.4-2.51,7.4-2.51,0,0,5.99,1.38,5.55,5.51-.13,1.2-.6,3.72-1.25,6.76.43.13.96.48.75,1.38l-.95-.44Zm-11.51-4.93l-.07,1.11-.17,2.66-.18,2.84,1.34.36c.87.24,1.74.46,2.62.66,1,.24,2.01.45,3.02.64l1.36.26,1.11-2.7,1.02-2.47.4-.96c-1.45-.91-3.03-1.57-4.67-1.99-.12-.03-.23-.06-.35-.08-1.77-.41-3.6-.53-5.42-.34Zm-3.8,17.73c.71-.8,1.19-1.79,1.38-2.86l.52-2.87.58-3.16c.1-.53.16-1.07.18-1.6l.12-2.66.16-3.53-4.09,17.7c.43-.29.82-.63,1.15-1.01Zm9.66,4.43l-.36-.91-.2-.49-.52-1.29s-1.37.49-3.78-.07c-.22-.05-.42-.1-.62-.16-1.97-.58-2.81-1.43-2.81-1.43l-1.04.94-.68.62-.42.38c.5,2.72,4.68,3.52,4.68,3.52,0,0,.36.1.9.18,1.3.19,3.7.29,4.85-1.29Zm4.88-18.43l-2.46,5.68c-.21.49-.4,1-.54,1.52l-1.66,5.91c-.43,1.54-.23,3.2.58,4.6l4.09-17.7Z" />
        </SvgIcon>
    )
}

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {Object}
 */
LaneWeavingIcon.defaultProps = {
    viewBoxSize: 48
}
